import React, { useState, useEffect } from 'react';
import { FaSun, FaMoon } from 'react-icons/fa';

export default function Terms() {
      const [dark, setDark] = useState(true);
    
  return (
    <div className={dark ? 'dark' : ''}>
    <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-6 py-12 font-vazir max-w-4xl mx-auto leading-loose">
      <h1 className="text-2xl font-bold mb-6 text-center">قوانین و مقررات موجیم</h1>
      <p className="mt-4">کاربر:به هر شخص ثبت نام کننده به ازای هر شماره ی موبایل یکتا.</p>

      <p className="mt-4">هر گونه استفاده از خدمات سایت موجیم به معنی پذیرفتن شرایط مندرج در سایت موجیم می‌باشد. سایت موجیم هیچ توافقی با مربیان و ورزشکاران خارج از این شرایط ندارد. شرایط و قوانین زیر مربوط به تمام مربیان و ورزشکارانی است که به هر شکلی با سایت موجیم همکاری و از خدمات آن استفاده می‌کنند.</p>

      <p className="mt-4">با توجه به اینکه هویت و اطلاعات ارائه شده توسط ورزشکاران به هیچ وجه قابل راستی آزمایی نمی‌باشد، موجیم هیچ مسئولیت یا تعهدی در قبال اطلاعات ارائه شده توسط ورزشکاران از طریق ارسال درخواست از طریق سایت ندارد.</p>

      <p className="mt-4">ورزشکار موظف است در صورتیکه بیماری و یا نقضی که منجر به صدمه در حرکات تمرینی و یا رژیم های غذایی و یا مکمل ها می‌باشد را حتما در فرم پرسشنامه آنلاین ذکر کند. در صورتی که این موارد گفته نشود و بعد از ارسال برنامه هر گونه صدمه‌ای با در نظر گرفتن عدم اعلام از سوی ورزشکار صورت پذیرد، مسئولیت کامل آن با ورزشکار است.</p>

      <p className="mt-4">موجیم هیچ قرارداد، تعهدنامه یا سندی را با هیچ شخص حقیقی یا حقوقی در حوزه آموزش و طراحی برنامه منعقد نکرده است.</p>
      <p className="mt-4">چنانچه کاربر با یک شماره موبایل بیش از یک بار پلن پرمیموم خریداری نماید، هزینه بیمه حوادث ورزشی در اولین خرید برای ایشان محاسبه شده و در دفعات بعدی این هزینه به کاربر عودت داده می شود.</p>
      <p className="mt-4">ملاک عودت هزینه بیمه حوادث ورزشی در تکرار خرید پلن پرمیوم، شماره ی موبایل کاربر می باشد و نه مشخصات فردی شخص.</p>


    </div>
                  <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
    </div>
  );
}
